<template>
  <VList dense>
    <template v-for="(item, index) in menuItems">
      <VListTile
        :key="index"
        :to="item.route"
      >
        <VListTileAction>
          <VIcon>{{ item.icon }}</VIcon>
        </VListTileAction>
        <VListTileContent>
          <VListTileTitle>
            {{ $t(item.text) }}
          </VListTileTitle>
        </VListTileContent>
      </VListTile>
    </template>
  </VList>
</template>

<script>
export default {
  name: 'SidebarBlock',
  computed: {
    menuItems () {
      return [
        { icon: 'business', text: 'agencies', route: { name: 'agencies' } },
        { icon: 'business', text: 'agencySettings', route: { name: 'agencySettings' } },
        { icon: 'people', text: 'agencyAgents', route: { name: 'agencyAgents' } },
        { icon: 'assignment', text: 'agencyContracts', route: { name: 'agencyContracts' } },
        { icon: 'cloud_download', text: 'agencyStatements', route: { name: 'agencyStatements' } },
        { icon: 'note_add', text: 'contractCreate', route: { name: 'contractCreate' } },
        { icon: 'library_books', text: 'agentContracts', route: { name: 'agentContracts' } },
        { icon: 'account_box', text: 'users', route: { name: 'users' } },
        { icon: 'settings', text: 'settings', route: { name: 'settings' } }].filter(entry => {
        return this.$can('enterRoute', entry.route.name)
      })
    }
  },
  i18n: {
    messages: {
      de: {
        settings: 'Einstellungen',
        customerCreate: 'Neuer Kunde',
        contractCreate: 'Neuer Vertrag',
        agentContracts: 'Vertragsübersicht',
        agencySettings: 'Agentureinstellungen',
        agencyAgents: 'Mitarbeiter',
        agencyContracts: 'Verträge',
        agencyStatements: 'Abrechnungen',
        agencies: 'Agenturen',
        users: 'Benutzer'
      },
      en: {}
    }
  }
}
</script>

<style scoped>

</style>
